import _ from './underscore.js';

// Helper function to continue chaining intermediate results.
export default function chainResult(instance, obj) {
  return instance._chain ? _(obj).chain() : obj;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_chainResult.js
// module id = 60
// module chunks = 0